import { BusinessMemberProfile, BusinessProfile } from "../types/business";
import { PubExpertProfile } from "../types/expert";
import { Lead, LeadCreate } from "../types/leads";
import { Meeting } from "../types/meetings";
import { appServerFetch } from "./api";

// FIXME: need to migrate into env variable
const API_TRIPLINK_URL = "https://dev-api.triplink.vip"

export const getTripLinkUserSignin = (accessToken: string): Promise<any> => {
  const url = `${API_TRIPLINK_URL}/api/auth/login`;
  return appServerFetch<any>(url, "POST", accessToken)
}

export const getExpertProfile = (accessToken: string): Promise<any> => {
  const url = `${API_TRIPLINK_URL}/api/experts/me`
  return appServerFetch<any>(url, "GET", accessToken)
}

export const getPubExpertProfile = (preferred_link: string): Promise<PubExpertProfile> => {
  const url = `${API_TRIPLINK_URL}/api/public/experts/${preferred_link}`
  return appServerFetch<any>(url, "GET")
}

export const createExpertProfile = (accessToken: string): Promise<any> => {
  const url = `${API_TRIPLINK_URL}/api/experts/`
  return appServerFetch<any>(url, "POST", accessToken)
}

export const updateExpertProfile = (accessToken: string, data: Record<string, any>): Promise<any> => {
  const url = `${API_TRIPLINK_URL}/api/experts/me`
  return appServerFetch<any>(url, "PUT", accessToken, data)
}

export const getEntitledFeatures = async (accessToken: string): Promise<any> => {
  const url = `${API_TRIPLINK_URL}/api/products/entitled-features-for-user`;
  return appServerFetch<any>(url, "GET", accessToken)
}

export const getMyBusinessProfile = async (accessToken: string): Promise<BusinessProfile> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/my-business`;
  return appServerFetch<BusinessProfile>(url, "GET", accessToken)
}

export const updateMyBusinessProfile = async (accessToken: string, data: Record<string, any>): Promise<BusinessProfile> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/my-business`;
  return appServerFetch<BusinessProfile>(url, "PUT", accessToken, data)
}

export const getMyBusinessMembers = async (accessToken: string): Promise<BusinessMemberProfile[]> => {
  const url = `${API_TRIPLINK_URL}/api/business-members`;
  return appServerFetch<BusinessMemberProfile[]>(url, "GET", accessToken)
}

export const checkBusinessDomainNameAvailability = async (domainName: string): Promise<boolean> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/domain-name-availability?domain_name=${domainName}`;
  return appServerFetch<boolean>(url, "GET")
}

export const isDomainChangeAllowed = async (accessToken: string): Promise<boolean> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/is-domain-change-allowed`;
  return appServerFetch<boolean>(url, "GET", accessToken)
}

export const setDomainName = async (accessToken: string, data: Record<string, any>): Promise<BusinessProfile> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/set-domain-name`;
  return appServerFetch<BusinessProfile>(url, "POST", accessToken, data)
}

export const uploadExpertAvatar = async (accessToken: string, data: File): Promise<string> => {
  const url = `${API_TRIPLINK_URL}/api/experts/profile-avatars`;
  const body = new FormData()
  body.append("image", data)

  const headers: Record<string, string> = {}

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`
  }

  const options: RequestInit = {
    method: "POST",
    headers,
    body,  
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Upload failed: ${response.status} - ${error}`)
  }

  return response.json()
}

export const uploadBusinessLogo = async (accessToken: string, data: File): Promise<string> => {
  const url = `${API_TRIPLINK_URL}/api/businesses/profile-logos`;
  const body = new FormData()
  body.append("image", data)

  const headers: Record<string, string> = {}

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`
  }

  const options: RequestInit = {
    method: "POST",
    headers,
    body,  
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Upload failed: ${response.status} - ${error}`)
  }

  return response.json()
}

export const getMyLeads = async (accessToken: string) => {
  const url = `${API_TRIPLINK_URL}/api/leads/me`;
  return appServerFetch<Lead[]>(url, "GET", accessToken)
}

export const createNewLead = async (preferredLink: string, data: Record<string, any>) => {
  const url = `${API_TRIPLINK_URL}/api/leads/${preferredLink}`;
  return appServerFetch<LeadCreate>(url, "POST", undefined, data)
}

export const getMyMeetings = async (accessToken: string) => {
  const url = `${API_TRIPLINK_URL}/api/meetings/me`;
  return appServerFetch<Meeting[]>(url, "GET", accessToken)
}

export interface SubscriptionItemInterface {
  subscription_id: number;
  product_id: string;
  price_id: number;
  quantity: number;
  quantity_at_period_end: number | null;
  remove_at_period_end: number | null;
  price?: {
    [key: string]: any;
    id: number,
    product_id: string,
    amount: string, //FIXME this should be converted to a money safe number type.
    currency: string,
    interval: 'month' | 'year',
    interval_count: number,
    meta: any,
    lookup_key: string | null,
  };
  product?: {
    id: string,
    name: string,
    description: string,
    meta: any,
    is_addon: boolean,
  };
}
export interface SubscriptionInterface {
  [key: string]: any;
  id: number,
  subscriber_id: string,
  subscriber_type: "user" | "business",
  billing_user_id: number,
  plan_name: string,
  price_total: any,//FIXME make sure money type is handled properly, without floatingpoint errors.
  currency: string,
  start_date: string,
  end_date: string | null,
  status: string,
  cancel_at_period_end: boolean,
  missing_payment_method: boolean,
  provider: string,
  provider_ref: string | null,
  created_at: string,
  items?: SubscriptionItemInterface[],
}
export const getEffectiveSubscription = async (
  accessToken: string
): Promise<SubscriptionInterface | null> => {
  const url = `${API_TRIPLINK_URL}/api/subscriptions/me/effective-sub`;
  return appServerFetch<SubscriptionInterface | null>(
    url, "GET", accessToken
  )
}

interface changeSubscriptionProductsResponse {
  success: boolean;
  pending_payment: boolean;
}
export const changeSubscriptionProducts = async (
  accessToken: string,
  body: object
): Promise<changeSubscriptionProductsResponse> => {
  const url = `${API_TRIPLINK_URL}/api/subscriptions/change-products`;
  return appServerFetch<changeSubscriptionProductsResponse>(
    url, "POST", accessToken, body
  )
}

interface changeSubscriptionQuantityResponse {
  success: boolean;
  pending_payment: boolean;
}
export const changeSubscriptionQuantity = async (
  accessToken: string,
  body: object
): Promise<changeSubscriptionQuantityResponse> => {
  const url = `${API_TRIPLINK_URL}/api/subscriptions/change-quantity`;
  return appServerFetch<changeSubscriptionQuantityResponse>(
    url, "POST", accessToken, body
  )
}

interface createStripeCheckoutSessionResponse {
  id: string;
  url: string;
  status: string;
  payment_status: string;
  expires_at: number | string;
  client_secret: string | null;
}
export const createStripeCheckoutSession = async (
  accessToken: string,
  body: object
): Promise<createStripeCheckoutSessionResponse> => {
  const url = `${API_TRIPLINK_URL}/api/stripe/create-checkout-session`;
  return appServerFetch<createStripeCheckoutSessionResponse>(
    url, "POST", accessToken, body
  )
}

interface finishStripeCheckoutSessionResponse {
  subscription: SubscriptionInterface | null;
  success: Boolean;
}
export const finishStripeCheckoutSession = async (
  accessToken: string,
  body: object
): Promise<finishStripeCheckoutSessionResponse> => {
  const url = `${API_TRIPLINK_URL}/api/stripe/finish-checkout-session`;
  return appServerFetch<finishStripeCheckoutSessionResponse>(
    url, "POST", accessToken, body
  )
}

interface createStripePortalSessionResponse {
  id: string;
  url: string;
  flow: {type: string};
}
export const createStripePortalSession = async (
  accessToken: string,
  body: object
): Promise<createStripePortalSessionResponse> => {
  const url = `${API_TRIPLINK_URL}/api/stripe/create-portal-session`;
  return appServerFetch<createStripePortalSessionResponse>(
    url, "POST", accessToken, body
  )
}
